import { useContext, useState } from "react";
import { Button } from "@mui/material";
import ModalContext from "../../../context/ModalContext";
import { deleteTag, deleteTopic } from "../../blogApi";

/*
 * Deleting a tag or topic in blog-api just drops the label from its posts, so
 * no confirmation beyond this is needed. (Authors are the exception — blog-api
 * answers 409 if one is still credited on a post.)
 */
const KINDS = {
  tag: { heading: "Delete Tag", page: "Tags", remove: deleteTag },
  topic: { heading: "Delete Topic", page: "Topics", remove: deleteTopic },
};

const DeleteTermModal = ({ modalDetails, kind }) => {
  const modalCtx = useContext(ModalContext);
  const config = KINDS[kind];
  const [error, setError] = useState(null);

  const handleCloseModal = () => modalCtx.closeModal();

  const remove = () => {
    if (!modalDetails?.slug) return;
    setError(null);

    config.remove(modalDetails.slug)
      .then(() => {
        modalCtx.setPageUpdate({ page: config.page });
        modalCtx.closeModal();
      })
      .catch((err) => {
        console.error(err);
        setError(err.message);
      });
  };

  return (
    <div className="create-devotional-container">
      <div className="devotional-header"><h1>{config.heading}</h1></div>
      <div className="body-container create-container">
        <span>
          Are you sure you want to delete {modalDetails?.name ? `“${modalDetails.name}”` : `this ${kind}`}?
        </span>
        {error ? <p style={{ color: "#d32f2f", fontSize: "0.85rem" }}>{error}</p> : null}
      </div>
      <div className="footer-devotional">
        <Button style={{ color: "#555" }} onClick={handleCloseModal}>No</Button>
        <Button style={{ color: "#555" }} onClick={remove}>Yes</Button>
      </div>
    </div>
  );
};

export default DeleteTermModal;
